import React from "react";
import { connect } from "react-redux";
import { Button } from "@vitalsource/vstui";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import OnboardingDialog from "./dialog";
import { t, Translation } from "../core/translate";
import { selectors as brandSelectors } from "../../redux/brand";
import { QuestionMark } from "../apps/library/footer/icons";

const NoPaddingButton = createThemedComponent(Button, {
  Button_paddingHorizontal_withIconMedium: 0
});

const WelcomeOnboarding = ({
  onboardingEnabled,
  customOnboarding,
  forceFinish,
  customOrder
}) => {
  let cards = onboardingEnabled
    ? [
        {
          title: t("onboarding.new-library.introducing-swimlanes-title"),
          image: "/img/new_library_onboarding_1.svg",
          description: t(
            "onboarding.new-library.introducing-swimlanes-description"
          )
        },
        {
          title: t("onboarding.new-library.more-card-options-title"),
          image: "/img/new_library_onboarding_2.svg",
          description: t("onboarding.new-library.more-card-options-description")
        },
        {
          title: t("onboarding.new-library.in-the-details-title"),
          image: "/img/new_library_onboarding_3.svg",
          description: t("onboarding.new-library.in-the-details-description")
        },
        {
          title: t("onboarding.new-library.global-search-title"),
          image: "/img/new_library_onboarding_4.svg",
          description: t("onboarding.new-library.global-search-description")
        },
        {
          title: t("onboarding.new-library.future-help-title"),
          image: "/img/new_library_onboarding_5.svg",
          description: (
            <Translation
              id="onboarding.new-library.future-help-description"
              searchIcon={
                <NoPaddingButton
                  disabled
                  iconStart={<QuestionMark fill="#000" />}
                  label={t("base.help", "Help")}
                  naked
                />
              }
            />
          )
        }
      ]
    : [];
  const customCards = customOnboarding.filter(card => card.enabled);
  cards =
    customOrder === "append"
      ? cards.concat(customCards)
      : customCards.concat(cards);
  return <OnboardingDialog requireInteraction={forceFinish} cards={cards} />;
};

const mapStateToProps = state => ({
  onboardingEnabled: brandSelectors.getBrandValue(
    state,
    "Onboarding.enabled",
    []
  ),
  customOnboarding: brandSelectors.getBrandValue(
    state,
    "Onboarding.custom",
    []
  ),
  forceFinish: brandSelectors.getBrandValue(
    state,
    "Onboarding.forceFinish",
    false
  ),
  customOrder: brandSelectors.getBrandValue(
    state,
    "Onboarding.customOrder",
    "append"
  )
});

export default connect(mapStateToProps)(WelcomeOnboarding);
